import { render, staticRenderFns } from "./SlidesPopup.vue?vue&type=template&id=43b7ec28&scoped=true&"
import script from "./SlidesPopup.vue?vue&type=script&lang=js&"
export * from "./SlidesPopup.vue?vue&type=script&lang=js&"
import style0 from "./SlidesPopup.vue?vue&type=style&index=0&id=43b7ec28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b7ec28",
  null
  
)

export default component.exports